import { formatDateTime, toIso } from '../../../lib/formatDate';
import type { EvidenceItemListItem } from './evidenceTypes';

function instant(value: string | null) {
  return value ? (
    <time dateTime={toIso(value)} className="font-mono">
      {formatDateTime(value)}
    </time>
  ) : null;
}

/**
 * THE EVALUATION AUDIT, as `<PreviewTable>` rows — product call, 08 Oct 2026: *evaluation should
 * have audit detail: evaluation by/at and stored by/at*, ENTERED on the Evaluate form. The people
 * are personnel ids; `person` resolves one the way the page resolves every other.
 */
export function evaluationAuditRows(item: EvidenceItemListItem, person: (id: string | null) => string | null) {
  return [
    { label: 'Evaluated by', value: person(item.evaluatedByPersonnelId) },
    { label: 'Evaluated at', value: instant(item.evaluatedAt) },
    { label: 'Stored by', value: person(item.storedByPersonnelId) },
    { label: 'Stored at', value: instant(item.storedAt) },
  ];
}
